import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { formatWorkflowDate, parseWorkflowDate } from "./workflowRunData";

interface WorkflowDateFieldProps {
  label?: string;
  id?: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  disabled?: boolean;
  error?: boolean;
}

/**
 * The portal's DatePicker, small and full width. A date can be typed (MM/DD/YYYY) as well as picked,
 * like PostIF's dates since Bug 83249. While a date is half-typed the picker reports an Invalid Date;
 * that is ignored rather than saved, which would clear the field mid-typing. Clearing the field
 * still clears the value.
 */
const WorkflowDateField: React.FC<WorkflowDateFieldProps> = ({
  label,
  id,
  value,
  onChange,
  required = false,
  disabled = false,
  error = false,
}) => (
  <DatePicker
    label={label}
    value={parseWorkflowDate(value)}
    onChange={(date) => {
      if (date !== null && Number.isNaN(date.getTime())) return;
      onChange(formatWorkflowDate(date));
    }}
    disabled={disabled}
    slotProps={{
      textField: {
        id,
        size: "small",
        fullWidth: true,
        required,
        error,
      },
    }}
  />
);

export default WorkflowDateField;
